import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "email", "btn"]
  connect() {
    this.preventEnter();
  }
  
  preventEnter(e) {
    const thatButton = this.btnTarget;
    this.emailTarget.onkeypress = function (key) {
      let btn = 0 || key.keyCode || key.charCode;
      if (btn == 13) {
        key.preventDefault();
        thatButton.click();
      }
    } 
  }

}